module.exports = __webpack_public_path__ + "static/media/clinical-card-1.7ad1a832.png";